import React from 'react'
import { Col, Row } from 'react-bootstrap'
import DraganddropField from './Draganddropfield'
import WikipediaCheckbox from './wikipediaCheckbox'
import AwsConfig from '../../Config/AwsConfig'

export default function CrewUi(props) {
  const {
    name,
    inputData,
    inputFieldEnglish,
    truevalue,
    sendtruevalue,
    inputFieldTelugu,
    crewName,
    crewNameTelugu,
    sendcrewName,
    sendcrewNameTelugu,
    sendInputobjecttoParent,
    sendSearchBoolean,
    PersonsSelectedAutosuggestions,
    sendEditmode,
    editMode,
    searchBoolean,
    weight,
    handleCrewNameChange,
    finalfilteredcrewNames,
    crewSelectionFromSuggestion,
    crewEnglish,
    crewTelugu,
    SubmitCrewperson,
  } = props
  const compare = (a, b) => {
    const isSameUser = (a, b) => a.name_En === b.name_En

    // Get items that only occur in the left array,
    // using the compareFunction to determine equality.
    const onlyInLeft = (left, right, compareFunction) => {
      if (left.length > 0) {
        // console.log(right, 'right')
        return left?.filter(leftValue => {
          if (right.length > 0) {
            return !right?.some(rightValue => compareFunction(leftValue, rightValue))
          }

          return true
        })
      }

      return left
    }

    const onlyInA = onlyInLeft(a, b, isSameUser)
    const onlyInB = onlyInLeft(b, a, isSameUser)

    const result = [...onlyInA, ...onlyInB]
    // console.log(result, 'crew result')
    return result.length
  }

  const crewOkButtonDisable = () => crewName && crewNameTelugu

  const indication = props.modeUrl
    ? compare(props.editData[inputFieldEnglish], inputData[inputFieldEnglish]) === 0 ||
      props.active[inputFieldEnglish] === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  // console.log(inputData[inputFieldEnglish], `${inputFieldEnglish}`)
  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>
              {`${name}_En`}:
              {name === 'Director' || name === 'Producer' ? (
                <div className='mandatory'>*</div>
              ) : (
                <></>
              )}
            </label>
            {inputData[inputFieldEnglish] && inputData[inputFieldEnglish].length >= 1 && (
              <div>
                <DraganddropField
                  truevalue={truevalue}
                  sendtruevalue={sendtruevalue}
                  display={inputData[inputFieldEnglish]}
                  englishField={inputFieldEnglish}
                  displayte={inputData[inputFieldTelugu]}
                  namearr={crewName}
                  namearrtel={crewNameTelugu}
                  sendname={sendcrewName}
                  sendnamete={sendcrewNameTelugu}
                  senddata={sendInputobjecttoParent}
                  sendsearchtrue={sendSearchBoolean}
                  personnames={PersonsSelectedAutosuggestions}
                  sendEditmode={sendEditmode}
                  editData={props.editData}
                  editmode={editMode}
                  modeUrl={props.modeUrl}
                  active={props.active}
                  handleActiveChange={props.handleActiveChange}
                  weight={weight + 1}
                />
              </div>
            )}
            {props.modeUrl && (
              <WikipediaCheckbox
                Id={name}
                field={inputFieldEnglish}
                active={props.active}
                handleActiveChange={props.handleActiveChange}
              />
            )}
            {searchBoolean && (
              <input
                type={'text'}
                className='form-control'
                style={props.modeUrl && indication}
                value={crewName}
                onChange={e => handleCrewNameChange(e.target.value)}
              ></input>
            )}
            {finalfilteredcrewNames.length >= 1 && searchBoolean && (
              <div
                className='searchfield'
                style={{
                  width: '200%',
                  position: 'relative',
                  zIndex: '1',
                }}
              >
                {searchBoolean &&
                  finalfilteredcrewNames.map((crewName, crewIndex) => {
                    let { posterURL } = crewName
                    if (posterURL === 'none' || posterURL === '') {
                      posterURL =
                        AwsConfig.movieCdnUrl + AwsConfig.avatharPath + AwsConfig.personStaticImage
                    } else if (posterURL && !posterURL.includes(AwsConfig.movieCdnUrl)) {
                      posterURL = AwsConfig.movieCdnUrl + posterURL
                    }

                    return (
                      <div
                        key={crewIndex}
                        onClick={() => crewSelectionFromSuggestion(crewIndex)}
                        style={{
                          width: '100%',
                          marginRight: '10px',
                          boxSizing: 'unset',
                          height: '3.5rem',
                        }}
                      >
                        <ul className='list-group list-group-flush' style={{ height: '3.5rem' }}>
                          <li
                            className='list-group-item'
                            style={{ marginRight: 'auto', width: '100%', height: '3.5rem' }}
                          >
                            <div className='media d-flex justify-content-center align-items-center'>
                              {crewName && crewName.label && crewName.label.includes('Create') ? (
                                ''
                              ) : (
                                <img
                                  style={{ width: '2rem', height: '2rem', marginRight: 'auto' }}
                                  className='mr-3 align-self-center'
                                  src={posterURL}
                                />
                              )}
                              <div
                                className='media-body align-self-center'
                                style={{ display: 'flex', flexWrap: 'wrap', fontSize: '10px' }}
                              >
                                {crewIndex === 0 ? (
                                  <label style={{ position: 'relative', left: '140px' }}>
                                    {crewName.label}
                                  </label>
                                ) : (
                                  <>
                                    <span>
                                      <b>Name:</b>
                                      <span style={{ fontSize: '10px' }}>{crewName.label}</span>
                                      {crewName.roles?.length > 0
                                        ? `(${[...new Set(crewName.roles)]
                                            .slice(0, Math.min(crewName.roles.length, 5))
                                            .toString()})`
                                        : ''}
                                    </span>
                                    <br />
                                    <span>{crewName.personWikiURL}</span>
                                  </>
                                )}
                              </div>
                            </div>
                          </li>
                          <hr style={{ background: 'black', color: 'black' }} />
                        </ul>
                      </div>
                    )
                  })}
              </div>
            )}
            {!searchBoolean && (
              <input
                type='text'
                className='form-control'
                value={crewName}
                style={{ width: '100%' }}
                onChange={event => crewEnglish(event)}
              />
            )}
          </div>
        </Col>
        {(!searchBoolean ||
          (inputData[inputFieldTelugu] && inputData[inputFieldTelugu].length >= 1)) && (
          <Col md={6} xs={12}>
            <div>
              <label>{`${name}_Te`}:</label>
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    border: '1px solid lightgray',
                    borderRadius: '1rem',
                  }}
                  className='rounded'
                >
                  {inputData[inputFieldTelugu].map((e, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '10px',
                        border: '1px solid black',
                        padding: '3px',
                        borderRadius: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        minWidth: '100px',
                        minHeight: '45px',
                        // justifyContent: 'center',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        {inputData[inputFieldEnglish][index].isAnonymous ? (
                          ''
                        ) : (
                          <img
                            style={{
                              width: '2rem',
                              height: '2rem',
                              borderRadius: '50%',
                              marginRight: '15px',
                            }}
                            src={
                              AwsConfig.movieCdnUrl + inputData[inputFieldEnglish][index].posterURL
                            }
                            // alt={inputData[inputFieldEnglish][index].name_En}
                          />
                        )}
                        {inputData[inputFieldEnglish][index].isAnonymous ? (
                          <span
                            style={{
                              color: 'white',
                              backgroundColor: 'gray',
                              fontSize: '8px',
                              position: 'absolute',
                              top: '0px',
                              right: '10px',
                            }}
                          >
                            Anonymous
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <span>{e}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {!searchBoolean && (
                <input
                  type='text'
                  value={crewNameTelugu}
                  className='form-control'
                  onChange={event => crewTelugu(event)}
                />
              )}
            </div>
            {!searchBoolean && (
              <button
                style={{ float: 'right' }}
                disabled={!crewOkButtonDisable()}
                type='button'
                onClick={() => SubmitCrewperson()}
                className='btn btn-primary'
              >
                ok
              </button>
            )}
          </Col>
        )}
      </Row>
    </div>
  )
}
